'use strict';
const NodeTree = require('./multi-root/node-tree'),
	NodeTreeSet = require('./multi-root/node-tree-set'),
	PlacedRectSets = require('./multi-root/placed-rect-sets');

module.exports = function MultiRootLayout() {
	const self = this,
		nodeTreeSet = new NodeTreeSet();

	self.appendRootNodeLayout = (nodeDictionary, rootIdea) => {
		const nodeTree = new NodeTree({nodeDictionary, rootIdea});
		nodeTreeSet.append(nodeTree);
	};
	self.getCombinedLayout = (margin, callOptions) => {
		if (!margin) {
			throw new Error('invalid-args');
		}
		if (nodeTreeSet.count() > 1) {
			const contextNodeId = callOptions && callOptions.contextNode,
				placedRectSets = new PlacedRectSets(contextNodeId),
				positionNodeTree = function (nodeTree) {
					const rectSet = nodeTree.toRectSet(margin),
						rectSetPlacing = rectSet.translate(nodeTree.getCurrentOffset());
					if (!placedRectSets.hasIntersectionsOnRectSet(rectSetPlacing)) {
						placedRectSets.addPlacedRectSet(rectSetPlacing);
					} else {
						const movementOrigin = nodeTreeSet.getMovementOrigin(contextNodeId),
							requiredOffset = placedRectSets.translationRequiredToNotOverlap({rectSet: rectSetPlacing, appliedOffset: nodeTree.getCurrentOffset(), movementOrigin});
						nodeTree.setCurrentOffset(requiredOffset);
						placedRectSets.addPlacedRectSet(rectSet.translate(requiredOffset));
					}
				};
			nodeTreeSet.nodeTreesInPlacementOrder(contextNodeId).forEach(positionNodeTree);
		}
		return nodeTreeSet.allNodesOffset();
	};
};
